import { render, staticRenderFns } from "./VcfContactModal.vue?vue&type=template&id=306cfb4d&scoped=true&"
import script from "./VcfContactModal.vue?vue&type=script&lang=js&"
export * from "./VcfContactModal.vue?vue&type=script&lang=js&"
import style0 from "./VcfContactModal.vue?vue&type=style&index=0&id=306cfb4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "306cfb4d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306cfb4d')) {
      api.createRecord('306cfb4d', component.options)
    } else {
      api.reload('306cfb4d', component.options)
    }
    module.hot.accept("./VcfContactModal.vue?vue&type=template&id=306cfb4d&scoped=true&", function () {
      api.rerender('306cfb4d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/VcfContactModal.vue"
export default component.exports